module.exports = "<svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><polygon points=\"16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/compass.svg
// module id = p/pw
// module chunks = 0